import {PageSkeleton} from "../components/loading/GroupSkeleton";
import React, { useEffect, useState } from "react";
import { fetchAuthSession, signOut } from "aws-amplify/auth";
import AuthPage from "../pages/AuthPage";
import GroupSessionPage from "../pages/grouptrip/GroupSessionPage";

function decodeJwt(token: string): any {
  try {
    const payload = token.split(".")[1];
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
}

const AuthGate: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userEmail, setUserEmail] = useState<string | null>(null);
  const [userName, setUserName] = useState<string | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        if (idToken) {
          localStorage.setItem("idToken", idToken);
          const claims = decodeJwt(idToken);
          setUserEmail(claims?.email || null);
          setUserName(claims?.name || null);
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch {
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };
    checkAuth();
  }, []);

  const handleLogout = async () => {
    console.log("Signout")
    await signOut({ global: true });
    localStorage.removeItem("idToken");
    setIsAuthenticated(false);
    setUserEmail(null);
    window.location.reload();
  };

  if (isLoading) {
    return (
      <PageSkeleton/>
    );
  }

  if (!isAuthenticated) {
    return <AuthPage />;
  }

  return (
    <GroupSessionPage
      userEmail={userEmail}
      username={userName}
      onLogout={handleLogout}
    />
  );
};

export default AuthGate;
